import { makeStyles } from '@mui/styles'
import { MyAccountTheme, MainHeader } from '@dxp-module/themes'

const mainHeaderStyles = makeStyles<MyAccountTheme, object, MainHeader>(
  ({ palette, typography, breakpoints }) => ({
    headerContainer: {
      backgroundColor: palette.secondary.main,
    },
    header: {
      height: '50px',
      textAlign: 'center',
      position: 'relative',
      [breakpoints.down('md')]: {
        display: 'grid',
        height: 'auto',
      },

      '& $headerTitle': {
        fontSize: typography.fontXXL,
        color: palette.primary.contrastText,
      },
      [breakpoints.down('sm')]: {
        '& $headerTitle': {
          fontSize: typography.fontLG,
        },
      },
    },
    headerTitle: {
      fontWeight: 'inherit',
      display: 'inline-block',
      color: palette.primary.contrastText,
      lineHeight: '50px',
      fontFamily: typography.fontFamily,
      fontSize: typography.fontLG,
      [breakpoints.down('md')]: {
        gridRow: '2',
      },
    },
    buttonContainer: {
      position: 'relative',
      height: '50px',
      textAlign: 'center',
    },
    headerMenuIcon: {
      color: palette.primary.contrastText,
      display: 'flex',
      fontSize: '30px',
      position: 'absolute',
      left: '10px',
      top: '10px',
      [breakpoints.up('md')]: {
        display: 'none',
      },
    },
    backLinkText: {
      color: palette.primary.contrastText,
      display: 'flex',
      position: 'absolute',
      left: '10px',
      top: '13px',
      fontFamily: typography.fontFamily,
      fontSize: typography.fontSM,
      textDecoration: 'underline',
      alignItems: 'center',
      [breakpoints.down('md')]: {
        gridRow: '1',
        backgroundColor: palette.primary.main,
        fontSize: typography.fontXS,
        position: 'relative',
        top: 0,
        width: '100%',
        left: 0,
        justifyContent: 'center',
      },
      '& $backLinkIcon': {
        display: 'flex',
      },
    },
    backLinkIcon: {
      color: palette.primary.contrastText,
      position: 'relative',
      [breakpoints.down('md')]: {
        top: '0',
      },
    },
    hideBackLink: {
      [breakpoints.up('md')]: {
        display: 'none',
      },
    },
  }),
  { name: 'MyAccount_Common_MainHeader' }
)

export default mainHeaderStyles
